import React from 'react'
import { connect } from 'react-redux'
import { servicesAPI } from 'supporticon/utils/client'
import { isJustGiving } from '../../../lib/environment'
import { clearSession, refreshUser, selectUser } from '../../../store/session'

class Reconnect extends React.Component {
  componentDidMount () {
    const { clearSession, refreshUser, user = {} } = this.props

    if (isJustGiving() && user.refreshToken) {
      const body = { token: user.refreshToken }
      servicesAPI.post('/v1/justgiving/oauth/reconnect', body)
        .then(response => response.data)
        .then(data => {
          const params = {
            refreshToken: data.refresh_token,
            token: data.access_token,
            authType: 'Bearer'
          }

          refreshUser(params)
        })
        .catch(error => {
          clearSession()
          return Promise.reject(error)
        })
    }
  }

  render () {
    return this.props.children
  }
}

const mapStateToProps = state => ({
  user: selectUser(state)
})

const mapDispatchToProps = { clearSession, refreshUser }

export default connect(mapStateToProps, mapDispatchToProps)(Reconnect)
